module.exports = __webpack_public_path__ + "static/media/WB_Desire.b9a45446.png";